import Swiper, { Lazy, Navigation } from 'swiper';
require ('../../../../jquery.matchHeight.js');

function applyMatchHeight() {
    if (window.innerWidth > 560) {
        $('.cms-content-trim-level__color-picker-slider-container').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.cms-content-trim-level__card--available-electric').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    } else {
        $('.cms-content-trim-level__color-picker-slider-container').matchHeight({ remove: true });
        $('.cms-content-trim-level__card--available-electric').matchHeight({ remove: true });
    }
}


function initializeRootSlider(rootEl) {
    return new Swiper(rootEl, {
        modules: [Navigation],
        navigation: {
            nextEl: rootEl.querySelector('.cms-content-trim-level--next'),
            prevEl: rootEl.querySelector('.cms-content-trim-level--prev'),
        },
        breakpoints: {
            1400: {
                slidesPerView: 3,
                spaceBetween: 30,
                colorsPerPage: 5
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 30,
                colorsPerPage: 4
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
                colorsPerPage: 4
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
                colorsPerPage: 5
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 10,
                colorsPerPage: 4
            }
        },
    });
}

function initializeImageSlider(vehicle, initialSlide = 0) {
    const imageGalleryEl = vehicle.querySelector('.swiper__imageSlider');

    if (!imageGalleryEl) {
        return null;
    }

    const swiperOptions = {
        modules: [Lazy, Navigation],
        grabCursor: true,
        slidesPerView: 1,
        speed: 400,
        loop: true,
        navigation: {
            nextEl: '.cms-content-trim-level__swiper-next',
            prevEl: '.cms-content-trim-level__swiper-prev',
        },
        initialSlide: initialSlide,
        preloadImages: false,
        lazy: {
            enabled: true,
            checkInView: true,
            preloaderClass: 'cms-content-trim-level__preloader',
        }
    };

    return new Swiper(imageGalleryEl, swiperOptions);
}

function initializeColorPicker(vehicle, rootSlider) {
    const colorPickerSlider = vehicle.querySelector('#color-picker-slider');
    const prevButton = vehicle.querySelector('.prev-button');
    const nextButton = vehicle.querySelector('.next-button');
    const colorPickerItems = vehicle.querySelectorAll('.cms-content-trim-level__swatch-outer');

    let currentStartIndex = 0;

    const windowWidth = window.innerWidth;
    const breakpoints = rootSlider.params.breakpoints;

    let colorsPerPage = 5;

    Object.keys(breakpoints).forEach(breakpoint => {
        if (windowWidth >= breakpoint && breakpoints[breakpoint]) {
            colorsPerPage = breakpoints[breakpoint].colorsPerPage;
        }
    });

    // Find the initially selected color
    const initiallySelectedColor = vehicle.querySelector('.cms-content-trim-level__swatch-outer--active');
    if (initiallySelectedColor) {
        const selectedIndex = Array.from(colorPickerItems).indexOf(initiallySelectedColor);
        if (selectedIndex >= 0) {
            currentStartIndex = Math.max(0, Math.min(selectedIndex - 2, colorPickerItems.length - colorsPerPage));
        }
    }

    prevButton.addEventListener('click', () => showColors(-1));
    nextButton.addEventListener('click', () => showColors(1));

    colorPickerItems.forEach((colorPickerItem, index) => {
        colorPickerItem.addEventListener('click', (e) => {
            e.preventDefault();
            const selectedPaint = colorPickerItem.getAttribute('data-paint');
            colorPickerItems.forEach(item => item.classList.remove('cms-content-trim-level__swatch-outer--active'));
            colorPickerItem.classList.add('cms-content-trim-level__swatch-outer--active');
            updateImages(selectedPaint, vehicle);
            currentStartIndex = Math.max(0, Math.min(index - 2, colorPickerItems.length - colorsPerPage));
            updateColorPicker();
        });
    });

    updateColorPicker();

    function showColors(direction) {
        currentStartIndex = Math.max(0, Math.min(currentStartIndex + direction * colorsPerPage, colorPickerItems.length - colorsPerPage));
        updateColorPicker();
    }

    function updateColorPicker() {
        colorPickerSlider.innerHTML = '';
        const visibleColors = Array.from(colorPickerItems).slice(currentStartIndex, currentStartIndex + colorsPerPage);
        visibleColors.forEach(colorSwatch => {
            colorPickerSlider.appendChild(colorSwatch);
        });
        prevButton.style.display = currentStartIndex > 0 ? 'flex' : 'none';
        nextButton.style.display = currentStartIndex + colorsPerPage < colorPickerItems.length ? 'flex' : 'none';
    }
}

function adjustNavigationArrows(rootEl, rootSlider) {
    const currentIndex = rootSlider.activeIndex;
    const slideEls = rootEl.querySelectorAll('.cms-content-trim-level__no-special-offer');
    const slidesPerView = getSlidesPerView(rootSlider);

    const prevArrow = rootEl.querySelector('.cms-content-trim-level--prev');
    const nextArrow = rootEl.querySelector('.cms-content-trim-level--next');

    toggleArrowState(prevArrow, currentIndex === 0);
    toggleArrowState(nextArrow, currentIndex >= slideEls.length - slidesPerView);
}

function toggleArrowState(arrow, isDisabled) {
    arrow.classList.toggle('cms-content-trim-level__disabled', isDisabled);
    arrow.querySelectorAll('svg path').forEach(path => path.setAttribute('fill', isDisabled ? '#d8d8d8' : '#0093D6'));
}

function getSlidesPerView(rootSlider) {
    const windowWidth = window.innerWidth;
    const currentIndex = rootSlider.activeIndex;
    const breakpoints = rootSlider.params.breakpoints;
    let totalTrims = rootSlider.slides.length;
    let slidesPerView = 1;

    Object.keys(breakpoints).forEach(breakpoint => {
        if (windowWidth >= breakpoint && breakpoints[breakpoint]) {
            slidesPerView = breakpoints[breakpoint].slidesPerView;
        }
    });

    const displayedTrimCount = document.getElementById('trim-count');

    let displayCountText = ''
    if(totalTrims > slidesPerView){
        const displayCountAmount = slidesPerView === 1 ? currentIndex + 1 : `${currentIndex + 1} - ${currentIndex + slidesPerView}`;
        displayCountText = `Showing ${displayCountAmount} of ${totalTrims} trim levels available`
    }else{
        if(totalTrims === 1){
            displayCountText = `Showing the ${totalTrims} trim level available`
        }else{
            displayCountText = `Showing the ${totalTrims} trim levels available`
        }
    }

    if (displayedTrimCount) {
        displayedTrimCount.textContent = displayCountText;
    }

    return slidesPerView;
}

function updateImages(colorIdentifier, vehicle) {
    const imageSlider = vehicle.querySelector('.swiper__imageSlider');
    let currentSlide = null;
    if (imageSlider.swiper) {
        currentSlide = imageSlider.swiper.slides[imageSlider.swiper.activeIndex].getAttribute('data-swiper-slide-index');
    }
    const imagesToUpdate = vehicle.querySelectorAll('.cms-content-trim-level__vehicle-image-slider .cms-content-trim-level__figure');

    imagesToUpdate.forEach(figure => {
        const image = figure.querySelector('img');
        if (!image) {
            return;
        }
        const baseUrl = image.getAttribute('data-src') || image.getAttribute('src');
        const regex = /paintId=(\d+)/;
        const match = baseUrl.match(regex);

        if (!match) {
            console.error("Couldn't parse Imagin Studio URL to change paint ID", baseUrl);
            return;
        }

        const currentPaintId = match[1];
        const newSrc = baseUrl.replace(`paintId=${currentPaintId}`, `paintId=${colorIdentifier}`);
        image.setAttribute('data-src', newSrc);

        if (figure.getAttribute('data-swiper-slide-index') == currentSlide) {
            image.setAttribute('src', newSrc);
            updateSourceElement(figure, currentPaintId, colorIdentifier, true);
        } else {
            image.removeAttribute('src');
            updateSourceElement(figure, currentPaintId, colorIdentifier, false);
        }
    });

    // reinitializeImageSlider(vehicle);
}

function updateSourceElement(figure, currentPaintId, colorIdentifier, preload) {
    const sourceElement = figure.querySelector('source');
    const currentSrcset = sourceElement.getAttribute('data-srcset') || sourceElement.getAttribute('srcset');
    if (!currentSrcset) {
        return;
    }
    const newSrcset = currentSrcset.replace(`paintId=${currentPaintId}`, `paintId=${colorIdentifier}`);
    sourceElement.setAttribute('data-srcset', newSrcset);

    if (preload) {
        sourceElement.setAttribute('srcset', newSrcset);
    } else {
        sourceElement.removeAttribute('srcset');
    }
}


function reinitializeImageSlider(vehicle) {
    const imageSlider = vehicle.querySelector('.swiper__imageSlider');
    let currentSlide = 0;
    if (imageSlider && imageSlider.swiper) {
        currentSlide = imageSlider.swiper.realIndex;
        imageSlider.swiper.destroy(true, true);
    }

    initializeImageSlider(vehicle, currentSlide);
}

// function attachEventListeners(vehicle) {
//     const colorPickerItems = vehicle.querySelectorAll('.cms-content-trim-level__swatch-outer');
//     colorPickerItems.forEach(colorPickerItem => {
//         colorPickerItem.addEventListener('click', (e) => {
//             e.preventDefault();
//             const selectedPaint = colorPickerItem.getAttribute('data-paint');
//             colorPickerItems.forEach(item => item.classList.remove('cms-content-trim-level__swatch-outer--active'));
//             colorPickerItem.classList.add('cms-content-trim-level__swatch-outer--active');
//             updateImages(selectedPaint, vehicle);
//         });
//     });
// }

export const initTrimLevel = function(rootEl) {
    const rootSlider = initializeRootSlider(rootEl);
    rootSlider.on('slideChange', () => adjustNavigationArrows(rootEl, rootSlider));

    const slideEls = rootEl.querySelectorAll('.cms-content-trim-level__no-special-offer');
    if (slideEls.length > 0) {
        slideEls.forEach((vehicle) => {
            const imageSlider = initializeImageSlider(vehicle);
            if (imageSlider) {
                initializeColorPicker(vehicle, rootSlider);
            }
        });
    }

    adjustNavigationArrows(rootEl, rootSlider);
    window.addEventListener('resize', () => {
        adjustNavigationArrows(rootEl, rootSlider);
        applyMatchHeight();
    });

    applyMatchHeight();
};